import React, { useEffect, useState } from 'react';
//import logo from './logo.svg';

import {Routes, Route} from 'react-router-dom';
import Cookies from 'js-cookie';
import NavBar from './NavBar';
//import Report from './Report';
import Clock from './Clock';
import Admin from './Admin';
import Report from './Report';
import AddUser from './AddUser';
import EditUser from './EditUser';
import './App.css';
import UserAdmin from './UserAdmin';
import RestoreUser from './RestoreUser';
import DeleteUser from './DeleteUser';
import UnitsAdmin from './UnitsAdmin';
import AddUnit from './AddUnit';
import EditUnit from './EditUnit';
import DeleteUnit from './DeleteUnit';
import RestoreUnit from './RestoreUnit';
import Login from './Login';
import Logout from './Logout';
import AddTime from './AddTime';
import EditTime from './EditTime';
import Timesheets from './Timesheets';
import Locations from './Locations';
import AddLocation from './AddLocation';
import EditLocation from './EditLocation';
import DeleteLocation from './DeleteLocation';
import RestoreLocation from './RestoreLocation';
import ReportLoggedInUsers from './ReportLoggedInUsers';
import ReportPaid from './ReportPaid';
import FlaggedEntries from './FlaggedEntries';
import PaidEntriesByLocation from './PaidEntriesByLocation';
import AllEntriesByLocation from './AllEntriesByLocation';
import DeleteTime from './DeleteTime';

function App() {
	const [authCookie, setAuthCookie] = useState("")
	const [loggedIn,setLoggedIn] = useState(false)

	useEffect(() => {
		const cookie = Cookies.get("resilire_auth")
		if (cookie) {
			setAuthCookie(cookie)
		}

		if (authCookie !== "") {
			setLoggedIn(true)
		}
	}, [authCookie, loggedIn])

	if (loggedIn) {
		const decodedAuth = atob(authCookie)
		if (decodedAuth === 'admin') {
			return (
				<div>
					<NavBar />
					<Routes>
						<Route path="/" element={<Clock />} />
						<Route path="/admin" element={<Admin />} />
						<Route path="/timesheet" element={<Report />} />
						<Route path="/timesheetPaid" element={<ReportPaid />} />
						<Route path="/report/LoggedInUsers" element={<ReportLoggedInUsers />} />
						<Route path="/addUser" element={<AddUser />} />
						<Route path="/editUser" element={<EditUser />} />
						<Route path="/deleteUser" element={<DeleteUser />} />
						<Route path="/restoreUser" element={<RestoreUser />} />
						<Route path="/userAdmin" element={<UserAdmin />} />
						<Route path="/units" element={<UnitsAdmin />} />
						<Route path="/addUnit" element={<AddUnit />} />
						<Route path="/editUnit" element={<EditUnit />} />
						<Route path="/deleteUnit" element={<DeleteUnit />} />
						<Route path="/restoreUnit" element={<RestoreUnit />} />
						<Route path="/logout" element={<Logout />} />
						<Route path="/timesheets" element={<Timesheets />} />
						<Route path="/addTime" element={<AddTime />} />
						<Route path="/editTime" element={<EditTime />} />
						<Route path="/deleteTime" element={<DeleteTime />} />
						<Route path="/locations" element={<Locations />} />
						<Route path="/addLocation" element={<AddLocation />} />
						<Route path="/editLocation" element={<EditLocation />} />
						<Route path="/deleteLocation" element={<DeleteLocation />} />
						<Route path="/restoreLocation" element={<RestoreLocation />} />
						<Route path="/report/FlaggedEntries" element={<FlaggedEntries />} />
						<Route path="/report/PaidEntriesByLocation" element={<PaidEntriesByLocation />} />
						<Route path="/report/AllEntriesByLocation" element={<AllEntriesByLocation />} />
					</Routes>
				</div>
			);
		} else {
			return (
				<div>
					<NavBar />
					<Routes>
						<Route path="/" element={<Clock />} />
						<Route path="/logout" element={<Logout />}	/>					
					</Routes>
				</div>
			);
		}
	} else {
		return (
			<div>
				<Routes>
					<Route path="/" element={<Login />} />
				</Routes>
			</div>
		)
	}
}

export default App;
